import { useCallback } from 'react'
import { all, find } from 'lodash/fp'

import { useSession } from '../model/use-session'

export const useAccess = () => {
	const { user } = useSession()

	if (!user) {
		throw Error('User does not exist!')
	}
	const app = find({ name: 'pricing_platform' }, user.apps)
	const permissions = app?.permissions
	const checkRole = useCallback(
		(roles: string[]) => all((r) => app?.role_names?.includes(r), roles),
		[app?.role_names]
	)
	const checkPermissons = useCallback(
		(permissions: string[]) =>
			all((p) => app?.permissions?.includes(p), permissions),
		[app?.permissions]
	)

	return { checkPermissons, permissions, checkRole }
}
